import { render, staticRenderFns } from "./HeaderVideoChat.vue?vue&type=template&id=170138ef&scoped=true&"
import script from "./HeaderVideoChat.vue?vue&type=script&lang=js&"
export * from "./HeaderVideoChat.vue?vue&type=script&lang=js&"
import style0 from "./HeaderVideoChat.vue?vue&type=style&index=0&id=170138ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170138ef",
  null
  
)

export default component.exports